import App from './Menu.svelte';

const app = new App({
	target: document.body,
});

export default app;